import axios from 'axios';
import { format } from 'date-fns';
import { enGB } from 'date-fns/locale';
import apiEndPoints from './consts/api.js';

const { productionApi, uatApi, productionClaimsApi, uatClaimsApi, apiKey } =
  apiEndPoints;

export const isStaging = process.env.GATSBY_IS_STAGING;
export const isProd =
  (!isStaging &&
    (process.env.NETLIFY || process.env.GATSBY_NETLIFY) &&
    (process.env.BRANCH === 'main' || process.env.GATSBY_BRANCH === 'main')) ||
  process.env.GATSBY_IS_PROD === 'true';

// Note this is a MJS file so we can use it in gatsby-node

const dateTransformer = (data) => {
  if (data instanceof Date) {
    return format(new Date(data), 'yyyy-MM-dd', { locale: enGB });
  }

  if (typeof data === 'object' && data !== null && !Array.isArray(data)) {
    return Object.fromEntries(
      Object.entries(data).map(([key, val]) => [key, dateTransformer(val)])
    );
  }

  if (Array.isArray(data) && data.length >= 1) {
    return data.map((val) => dateTransformer(val));
  }
  return data;
};

export const getApiBaseUrl = () => {
  // Total override environment variable
  // Useful for PR branch testing and staging
  if (process.env.GATSBY_API_ENDPOINT) {
    return process.env.GATSBY_API_ENDPOINT;
  }

  return isProd ? productionApi : uatApi;
};
export const getApiBaseClaimsUrl = () => {
  // Total override environment variable
  // Useful for PR branch testing and staging
  if (process.env.GATSBY_CLAIMS_API_ENDPOINT) {
    return process.env.GATSBY_CLAIMS_API_ENDPOINT;
  }

  return isProd ? productionClaimsApi : uatClaimsApi;
};

export const service = axios.create({
  baseURL: getApiBaseUrl(),
  transformRequest: [dateTransformer].concat(axios.defaults.transformRequest),
  headers: {
    'Access-Token': apiKey,
    'Content-Type': 'application/json',
  },
});

export const claimsService = axios.create({
  baseURL: getApiBaseClaimsUrl(),
  transformRequest: [dateTransformer].concat(axios.defaults.transformRequest),
  headers: {
    'Access-Token': apiKey,
    'Content-Type': 'application/json',
  },
});

// service.defaults.headers.common.Origin = origin;
//
